export const REGISTRATION_ONBOARDING_GENDER_STORAGE_KEY =
  "vg_registration_onboarding_gender";
export const REGISTRATION_ONBOARDING_PREPARATION_STORAGE_KEY =
  "vg_registration_onboarding_preparation";

export function normalizeRegistrationOnboardingGender(value) {
  const normalized = String(value || "").trim().toLowerCase();
  return normalized === "male" || normalized === "female" ? normalized : "unknown";
}

export function storeRegistrationOnboardingGender(value) {
  const gender = normalizeRegistrationOnboardingGender(value);

  try {
    window.sessionStorage.setItem(REGISTRATION_ONBOARDING_GENDER_STORAGE_KEY, gender);
  } catch {
    // The onboarding has a neutral fallback when session storage is unavailable.
  }

  return gender;
}

export function storeRegistrationOnboardingPreparation({
  genderAssumption,
  newcomerEventResponse,
} = {}) {
  const preparation = {
    gender: storeRegistrationOnboardingGender(genderAssumption),
    showFirstStep: Boolean(
      newcomerEventResponse?.show_first_step && newcomerEventResponse?.event
    ),
    event: newcomerEventResponse?.event || null,
  };

  try {
    window.sessionStorage.setItem(
      REGISTRATION_ONBOARDING_PREPARATION_STORAGE_KEY,
      JSON.stringify(preparation)
    );
  } catch {
    // The onboarding can refetch availability when session storage is unavailable.
  }

  return preparation;
}

export function readRegistrationOnboardingPreparation() {
  try {
    const value = JSON.parse(
      window.sessionStorage.getItem(REGISTRATION_ONBOARDING_PREPARATION_STORAGE_KEY)
    );
    if (!value || typeof value.showFirstStep !== "boolean") return null;

    return {
      gender: normalizeRegistrationOnboardingGender(value.gender),
      showFirstStep: Boolean(value.showFirstStep && value.event),
      event: value.event || null,
    };
  } catch {
    return null;
  }
}

export function resolveRegistrationOnboardingGender({
  search = "",
  allowSearchOverride = false,
  profileGender = "",
  profileGenderAssumption = "",
} = {}) {
  if (allowSearchOverride) {
    const requestedGender = new URLSearchParams(search).get("gender");
    if (requestedGender) return normalizeRegistrationOnboardingGender(requestedGender);
  }

  const profileGenderValue = normalizeRegistrationOnboardingGender(profileGender);
  if (profileGenderValue !== "unknown") return profileGenderValue;

  const profileAssumptionValue = normalizeRegistrationOnboardingGender(profileGenderAssumption);
  if (profileAssumptionValue !== "unknown") return profileAssumptionValue;

  try {
    return normalizeRegistrationOnboardingGender(
      window.sessionStorage.getItem(REGISTRATION_ONBOARDING_GENDER_STORAGE_KEY)
    );
  } catch {
    return "unknown";
  }
}

export function applyRegistrationJourneyGenderedCopy(slides, genderedCopy) {
  return slides.map((slide, index) => {
    if (index === 0) return { ...slide, body: genderedCopy.introBody };
    if (index === 3) return { ...slide, body: genderedCopy.responsibilityBody };
    if (index === 5) return {
      ...slide,
      title: genderedCopy.comeAloneTitle,
      body: genderedCopy.comeAloneBody,
    };
    if (index === 6) return { ...slide, body: genderedCopy.firstStepBody };
    return slide;
  });
}
